export const breakoutRoomSchema = `
  id
  name
  start
  end
  date
  type
  description
  coverImage
`;

export const typesEnum = {
  BREAKOUT: 'breakout_session',
  CHAT: 'chat_session',
};
